import React from 'react';
import Form from '../../../../components/molecules/Form/Form';
import AnnouncementConfirmFormTemplate from './AnnouncementConfirmFormTemplate';
import { FormContainerModifier } from '../../../../components/molecules/Form';
import IForm from '../../../../types/IForm';

export default function AnnouncementConfirmForm({ confirmForm }: { confirmForm: IForm }) {
  return (
    <Form
      id="mandatory-announcement-confirm-form"
      model={confirmForm}
      containerModifier={[FormContainerModifier.NO_PADDING_BOTTOM, FormContainerModifier.NO_PADDING_HORIZONTAL]}
    >
      <AnnouncementConfirmFormTemplate />
    </Form>
  );
}
